import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { INFO_PAGE_LINKS } from "../InfoPages/infoPagesConfig";
import { FaLinkedin } from "react-icons/fa";

export default function Footer() {
    const { t } = useTranslation();
    const iconBase = process.env.PUBLIC_URL || '';
    const currentYear = new Date().getFullYear();

    return (
        <footer className="info-footer">
            <div className="container info-footer__container info-footer--modern">
                <div className="info-footer__brand">
                    <div className="meanc-logo meanc-logo--footer">
                        <div className="meanc-logo-icon">
                            <span>M</span>
                            <span>C</span>
                        </div>
                        <div className="meanc-logo-type">
                            <strong>MEANC</strong>
                            <small>software</small>
                        </div>
                    </div>
                    <p className="info-footer__tagline">
                        Software for live fans, smooth amenities, secure creators, and tidy engineering.
                    </p>
                    <a className="info-footer__cta" href="mailto:services@meanc.net">Talk to us</a>
                </div>

                <div className="info-footer__grid">
                    <div className="info-footer__column">
                        <p className="info-footer__heading">Products</p>
                        <a href="/#products" className="info-footer__link">RivalCam</a>
                        <a href="https://smartamenity.net" target="_blank" rel="noreferrer" className="info-footer__link">Smart Amenity</a>
                        <a href="/#products" className="info-footer__link">ContentTamper</a>
                        <a href="/#products" className="info-footer__link">EnvGuard</a>
                    </div>
                    <div className="info-footer__column">
                        <p className="info-footer__heading">Company</p>
                        <a href="/#about" className="info-footer__link">About</a>
                        <Link to="/info/career" className="info-footer__link">{t('career')}</Link>
                        <Link to="/info/help-center" className="info-footer__link">{t('help_center')}</Link>
                    </div>
                    <div className="info-footer__column">
                        <p className="info-footer__heading">Legal</p>
                        <Link to="/info/privacy" className="info-footer__link">{t('privacy_policy')}</Link>
                        <Link to="/info/terms" className="info-footer__link">{t('termsAndConditions')}</Link>
                        <Link to="/info/cookies" className="info-footer__link">{t('cookies_policy')}</Link>
                    </div>
                    <div className="info-footer__column">
                        <p className="info-footer__heading">Contact</p>
                        <a href="mailto:services@meanc.net" className="info-footer__link">services@meanc.net</a>
                        <a href="https://www.linkedin.com/in/mosesdm/" target="_blank" rel="noreferrer" className="info-footer__link">
                            <FaLinkedin aria-hidden="true" /> LinkedIn
                        </a>
                    </div>
                </div>
            </div>
            <div className="info-footer__bottom">
                <p>© {currentYear} MEANC Technologies – All Rights Reserved</p>
                <div className="info-footer__bottom-links">
                    {INFO_PAGE_LINKS.map((link) => (
                        <Fragment key={link.slug}>
                            <Link className="info-footer__link" to={`/info/${link.slug}`}>
                                {t(link.labelKey)}
                            </Link>
                        </Fragment>
                    ))}
                </div>
                <img
                    className="info-footer__logo"
                    src={`${iconBase}/images/img2/meanclogo5.png`}
                    alt="Meanc"
                />
            </div>
        </footer>
    );
}
